import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import makeStyles from '@mui/styles/makeStyles';

import Typography from '@ts-core/components/Typography';

const useStyles = makeStyles((theme) => ({
  processedState: {
    color: theme.palette.success.main,
  },
  processingState: {
    color: theme.palette.warning.main,
  },
}));

const MediaItemStateCell = (props) => {
  const classes = useStyles();
  const { processed } = props;
  return (
    <Typography
      className={processed ? classes.processedState : classes.processingState}
    >
      <FormattedMessage
        id={processed ? 'media.state.processed' : 'media.state.processing'}
      />
    </Typography>
  );
};

MediaItemStateCell.propTypes = {
  processed: PropTypes.bool,
};

MediaItemStateCell.defaultProps = {
  processed: false,
};

export default MediaItemStateCell;
